import { INVOICE_ACTIONS, INVOICE_STATUS, DOWNLOAD_URL } from '@/app-constant';
import CheckPermissionMixin from '@/mixins/check-permission';
import ReleaseInvoiceMixin from '@/mixins/release-invoice';
import { EInvoiceProxy } from '@/store/proxies/e-invoice';
import { buildActionInvoiceItem } from '@/utils/invoice';
import ToastUtils from '@/utils/toast';
import { UnpublishInvoiceProxy } from '@/store/proxies/e-invoice';

const ActionsMenuMixin = {
  name: 'ActionsMenuMixin',
  mixins: [CheckPermissionMixin, ReleaseInvoiceMixin],
  data() {
    return {
      filterData: {
        kindOf: false,
        id_pinvoice: null,
        status: null,
        codeTaxApproved: null,
        isTransferred: false,
        isHasCode: false,
        modify: null,
      },
    };
  },
  beforeDestroy() {
    this.filterData = {
      id: null,
      status: null,
      codeTaxApproved: null,
      isTransferred: false,
      isHasCode: false,
      modify: null,
    };
  },
  computed: {
    // Hóa đơn gốc
    originalInvoices() {
      if (this.filterData.isTransferred) {
        return [
          INVOICE_ACTIONS.ADJUST_INFO,
          INVOICE_ACTIONS.ADJUST_INCREASE_DECREASE,
          INVOICE_ACTIONS.ISSUE_REPLACEMENT_INVOICE,
          INVOICE_ACTIONS.DOWNLOAD_CONVERSION_INVOICE,
          INVOICE_ACTIONS.COPY_INVOICE,
        ];
      } return [
        INVOICE_ACTIONS.ADJUST_INFO,
        INVOICE_ACTIONS.ADJUST_INCREASE_DECREASE,
        INVOICE_ACTIONS.ISSUE_REPLACEMENT_INVOICE,
        INVOICE_ACTIONS.ISSUE_CONVERSION_INVOICE,
        INVOICE_ACTIONS.COPY_INVOICE,
      ];
    },

    // Hóa đơn thay thế
    replaceInvoice() {
      if (this.filterData.isTransferred) {
        return [
          INVOICE_ACTIONS.ISSUE_REPLACEMENT_INVOICE,
          INVOICE_ACTIONS.DOWNLOAD_CONVERSION_INVOICE,
          INVOICE_ACTIONS.COPY_INVOICE,
        ];
      } return [
        INVOICE_ACTIONS.ISSUE_REPLACEMENT_INVOICE,
        INVOICE_ACTIONS.ISSUE_CONVERSION_INVOICE,
        INVOICE_ACTIONS.COPY_INVOICE,
      ];
    },

    // Hóa đơn bị thay thế
    replacedInvoice() {
      return [];
    },

    // Hóa đơn điều chỉnh thông tin
    modifyInfoInvoice() {
      if (this.filterData.isTransferred) {
        return [
          INVOICE_ACTIONS.DOWNLOAD_CONVERSION_INVOICE,
        ];
      }
      return [
        INVOICE_ACTIONS.ISSUE_CONVERSION_INVOICE,
      ];
    },

    // Hóa đơn bị điều chỉnh thông tin
    modifiedInfoInvoice() {
      if (this.filterData.isTransferred) {
        if (this.filterData.isHasCode && this.filterData.codeTaxApproved === null) {
          return [
            INVOICE_ACTIONS.ADJUST_INFO,
            INVOICE_ACTIONS.ADJUST_INCREASE_DECREASE,
            INVOICE_ACTIONS.ISSUE_REPLACEMENT_INVOICE,
            INVOICE_ACTIONS.DOWNLOAD_CONVERSION_INVOICE,
          ];
        }
        return [
          INVOICE_ACTIONS.ADJUST_INFO,
          INVOICE_ACTIONS.ADJUST_INCREASE_DECREASE,
          INVOICE_ACTIONS.DOWNLOAD_CONVERSION_INVOICE,
        ];
      }
      return [
        INVOICE_ACTIONS.ADJUST_INFO,
        INVOICE_ACTIONS.ADJUST_INCREASE_DECREASE,
        INVOICE_ACTIONS.ISSUE_CONVERSION_INVOICE,
      ];
    },

    // Hóa đơn điều chỉnh tăng giảm
    modifyMoneyInvoice() {
      if (this.filterData.isTransferred) {
        return [
          INVOICE_ACTIONS.DOWNLOAD_CONVERSION_INVOICE,
        ];
      }
      return [
        INVOICE_ACTIONS.ISSUE_CONVERSION_INVOICE,
      ];
    },

    // Hóa đơn bị điều chỉnh tăng giảm
    modifiedMoneyInvoice() {
      if (this.filterData.isTransferred) {
        if (this.filterData.isHasCode && this.filterData.codeTaxApproved === null) {
          return [
            INVOICE_ACTIONS.ADJUST_INFO,
            INVOICE_ACTIONS.ADJUST_INCREASE_DECREASE,
            INVOICE_ACTIONS.DOWNLOAD_CONVERSION_INVOICE,
            // INVOICE_ACTIONS.SEND_TAX,
          ];
        }
        return [
          INVOICE_ACTIONS.ADJUST_INFO,
          INVOICE_ACTIONS.ADJUST_INCREASE_DECREASE,
          INVOICE_ACTIONS.DOWNLOAD_CONVERSION_INVOICE,
        ];
      }
      return [
        INVOICE_ACTIONS.ADJUST_INFO,
        INVOICE_ACTIONS.ADJUST_INCREASE_DECREASE,
        INVOICE_ACTIONS.ISSUE_CONVERSION_INVOICE,
      ];
    },

    // Hóa đơn hủy bỏ
    canceledInvoice() {
      return [];
    },

    // Hóa đơn nháp
    draftInvoice() {
      return [
        INVOICE_ACTIONS.ISSUE_INVOICE,
        INVOICE_ACTIONS.COPY_INVOICE,
        INVOICE_ACTIONS.DELETE_INVOICE
      ];
    },

    options() {
      const menu = new Set();

      // Thêm các action tương ứng với từng trạng thái
      if (this.filterData.status === INVOICE_STATUS.ORIGINAL) {
        this.originalInvoices.forEach(action => menu.add(action));
      } else if (this.filterData.status === INVOICE_STATUS.REPLACE) {
        this.replaceInvoice.forEach(action => menu.add(action));
      } else if (this.filterData.status === INVOICE_STATUS.REPLACED) {
        this.replacedInvoice.forEach(action => menu.add(action));
      } else if (this.filterData.status === INVOICE_STATUS.MODIFY) {
        if (this.filterData.modify === 'PRODUCT') {
          this.modifyMoneyInvoice.forEach(action => menu.add(action));
        } else if (this.filterData.modify === 'INFORMATION') {
          this.modifyInfoInvoice.forEach(action => menu.add(action));
        }
      } else if (this.filterData.status === INVOICE_STATUS.MODIFIED) {
        if (this.filterData.modify === 'UPDATED_PRODUCT') {
          this.modifiedMoneyInvoice.forEach(action => menu.add(action));
        } else if (this.filterData.modify === 'UPDATED_INFORMATION') {
          this.modifiedInfoInvoice.forEach(action => menu.add(action));
        }
      } else if (this.filterData.status === INVOICE_STATUS.CANCELED) {
        this.canceledInvoice.forEach(action => menu.add(action));
      } else if (this.filterData.status === INVOICE_STATUS.DRAFT) {
        this.draftInvoice.forEach(action => menu.add(action));
      }

      if (this.filterData.status !== INVOICE_STATUS.DRAFT) {
        // menu.add(INVOICE_ACTIONS.VIEW_CONVERSION_HISTORY);
        menu.add(INVOICE_ACTIONS.EXPLAIN_INVOICE);
      }

      if ([INVOICE_STATUS.CANCELED, INVOICE_STATUS.MODIFIED, INVOICE_STATUS.REPLACED].includes(this.filterData.status)) {
        menu.add(INVOICE_ACTIONS.PREPARE_ERROR_REPORT);
      }

      menu.add(INVOICE_ACTIONS.SEND_EMAIL);

      const filterExternalInvoiceActions = [
        INVOICE_ACTIONS.ISSUE_CONVERSION_INVOICE,
        INVOICE_ACTIONS.DOWNLOAD_CONVERSION_INVOICE,
        // INVOICE_ACTIONS.VIEW_CONVERSION_HISTORY,
        INVOICE_ACTIONS.EXPLAIN_INVOICE,
        INVOICE_ACTIONS.PREPARE_ERROR_REPORT,
        INVOICE_ACTIONS.SEND_EMAIL,
      ];

      let menuArray = Array.from(menu);
      if (!this.filterData.kindOf) {
        menuArray = [
          INVOICE_ACTIONS.COPY_INVOICE,
          INVOICE_ACTIONS.SEND_EMAIL,
        ];
      } else if (!this.filterData.id_pinvoice) {
        menuArray = menuArray.filter(action => !filterExternalInvoiceActions.includes(action));
      }

      return menuArray.map(actionKey => ({
        key: actionKey,
        name: this.$t(`actions.options.${actionKey}`),
        title: this.$t(`actions.title.${actionKey}`),
      }));
    },
  },
  methods: {
    optionClicked(props) {
      const { option, item } = props;
      switch (option.key) {
        case INVOICE_ACTIONS.DOWNLOAD_CONVERSION_INVOICE: {
          const urlDownload = DOWNLOAD_URL + encodeURIComponent(item.tranfered_pdf);
          window.open(urlDownload, 'blank');
        }
          break;
        case INVOICE_ACTIONS.SEND_EMAIL:
          this.$modal.show('send-email-modal', {
            model: item.buyer_obj,
            invoiceId: item.id_pinvoice,
            mailHistories: item.mail_histories,
          });
          break;
        case INVOICE_ACTIONS.ISSUE_CONVERSION_INVOICE:
          this.exportInvoiceChange(item.id_pinvoice).then((response) => {
            if (response) {
              ToastUtils.showToast('success', 'Chuyển đổi hóa đơn thành công !');
            }
          })
            .catch((errorCode) => {
              this.$modal.show('usb-token-error-modal', { model: { error: errorCode } });
            });
          break;
        case INVOICE_ACTIONS.SEND_TAX:
        case INVOICE_ACTIONS.VIEW_CONVERSION_HISTORY:
          this.$modal.show('dialog', {
            title: '',
            isAlert: true,
            text: 'Tính năng sẽ sớm có !',
          });
          break;
        case INVOICE_ACTIONS.PREPARE_ERROR_REPORT:
          this.$modal.show('error-reported-modal', { model: item });
          break;
        case INVOICE_ACTIONS.DELETE_INVOICE:
          this.$modal.show('dialog', {
            title: this.$t('invoice.deleteInvoice'),
            text: this.$t('invoice.deleteInvoiceConfirmMsg'),
            okText: this.$t('app.delete'),
            okClass: 'btn btn-danger btn-sm',
            onOk: () => {
              new UnpublishInvoiceProxy().deleteInvoice(item.id).then(() => {
                this.$bus.emit('update-invoice-success')
                ToastUtils.showToast('success', "Xóa hóa đơn thành công");
              });
            },
            showLoading: true
          });
          break;
        default: {
          const modalName = this.determineModalName('actions-invoice-modal');
          this.$modal.show(modalName, props);
        }
          break;
      }
    },
    getEInvoiceData(invoice) {
      return new Promise((resolve, reject) => {
        this.filterData = {
          ...this.filterData,
          id_pinvoice: invoice.id_pinvoice, // id hoá đơn pinvoice.
          kindOf: invoice.kind_of, // loại hóa đơn đầu vào hay đầu ra.
        };
        if (!invoice.id_pinvoice) {
          resolve(invoice);
          return;
        }
        new EInvoiceProxy().getEInvoice(invoice.id_pinvoice)
          .then((res) => {
            if (!res) {
              resolve(invoice);
              return;
            }
            const { id, ...dataBuyer } = res.buyer_obj || {};
            this.filterData = {
              ...this.filterData,
              status: res.status,
              codeTaxApproved: res.code_tax_approved, // Là mã cơ quan thuế cấp cho 1 hoá đơn.
              isTransferred: res.is_transfered,       // Hoá đơn này đã chuyển thành hoá đơn giấy không.
              isHasCode: res.is_ht_co_ma,             // hoá đơn này thuộc loại có mã hay không mã.
              modify: res.modify,                     // Thông tin thay đổi của hóa đơn.
            };
            resolve({
              ...invoice,
              ...dataBuyer,
              ...buildActionInvoiceItem(res),
            });
          })
          .catch((error) => {
            ToastUtils.showToast('error', error.message || error);
            reject(error);
          });
      });
    },
  },
};

export default ActionsMenuMixin;



// WEBPACK FOOTER //
// ./src/mixins/actions-menu.js